import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';

import regCallout3month from '../component/img/header_callout_3_25.png';
import regCallout6month from '../component/img/header_callout_6_50.png';
import regCallout9month from '../component/img/header_callout_9_75.png';
import confEmail from '../component/img/email_activate.png';
import confPayment from '../component/img/emailconf_th_creditcard.png';

export default class CopyProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  };

  render() {
    let copy = null;

    if (this.props.copyKey === 'registration_header_8012') {
      copy = (
        <div className="registration_header_content">
          <img src={ regCallout3month } alt="" />

          <span>
            <span className="blue">Exclusive offer for Borrow customers:</span> get a <span className="blue">$25 charging credit</span> added to your account and gain access to our cheapest members-only rates.
          </span>
        </div>
      );
    } else if (this.props.copyKey === 'registration_header_8013') {
      copy = (
        <div className="registration_header_content">
          <img src={ regCallout6month } alt="" />

          <span>
            <span className="blue">Exclusive offer for Borrow customers:</span> get a <span className="blue">$50 charging credit</span> added to your account and gain access to our cheapest members-only rates.
          </span>
        </div>
      );
    } else if (this.props.copyKey === 'registration_header_8014') {
      copy = (
        <div className="registration_header_content">
          <img src={ regCallout9month } alt="" />

          <span>
            <span className="blue">Exclusive offer for Borrow customers:</span> get a <span className="blue">$75 charging credit</span> added to your account and gain access to our cheapest members-only rates.
          </span>
        </div>
      );
    } else if (this.props.copyKey === 'registration_form_content_list_8012') {
      copy = (
        <div className="registration_form_content_list">
          <div className="bullet_list">Setting up an account is free and easy, and there are no recurring fees</div>
          <div className="bullet_list">A $25 promotional credit will be added to your account</div>
          <div className="bullet_list">Fast charge for free using the EVgo App or an RFID</div>
          <div className="bullet_list">Once you’ve used up your promotional credit, you can continue to charge at our lowest per-minute Member rate or switch to <span style={{ 'fontStyle': 'italic' }}>Pay As You Go</span></div>
          <div className="bullet_list">Start charging immediately using the EVgo app</div>
        </div>
      );
    } else if (this.props.copyKey === 'registration_form_content_list_8013') {
      copy = (
        <div className="registration_form_content_list">
          <div className="bullet_list">Setting up an account is free and easy, and there are no recurring fees</div>
          <div className="bullet_list">A $50 promotional credit will be added to your account</div>
          <div className="bullet_list">Fast charge for free using the EVgo App or an RFID</div>
          <div className="bullet_list">Once you’ve used up your promotional credit, you can continue to charge at our lowest per-minute Member rate or switch to <span style={{ 'fontStyle': 'italic' }}>Pay As You Go</span></div>
          <div className="bullet_list">Start charging immediately using the EVgo app</div>
        </div>
      );
    } else if (this.props.copyKey === 'registration_form_content_list_8014') {
      copy = (
        <div className="registration_form_content_list">
          <div className="bullet_list">Setting up an account is free and easy, and there are no recurring fees</div>
          <div className="bullet_list">A $75 promotional credit will be added to your account</div>
          <div className="bullet_list">Fast charge for free using the EVgo App or an RFID</div>
          <div className="bullet_list">Once you’ve used up your promotional credit, you can continue to charge at our lowest per-minute Member rate or switch to <span style={{ 'fontStyle': 'italic' }}>Pay As You Go</span></div>
          <div className="bullet_list">Start charging immediately using the EVgo app</div>
        </div>
      );
    } else if (this.props.copyKey === 'email_confirmation_content_list_account_created') {
      copy = (
        <div>
          <div className="bullet_list">An active credit card is needed for you account, but you will not pay anything unless you exceed your promotional credit amount</div>
          <div className="bullet_list">There are no monthly fees.</div>
          <div className="bullet_list">After credit, you will be able to charge at our lowest per-minute Member rate for the remainder of your rental period.</div>
        </div>
      );
    } else if (this.props.copyKey === 'email_confirmation_title_account_created') {
      copy = (
        <div className="email_confirmation_body_content_header">Almost done! To finish registration:</div>
      );
    } else if (this.props.copyKey === 'email_confirmation_subtitle_account_created') {
      copy = (
        <div className="email_confirmation_body_content_body_top">
          <div className="email_confirmation_body_content_body_top_info">
            <span>Please check your email and click the validation link</span>
            <img src={ confEmail } alt="" />
          </div>

          <div className="email_confirmation_body_content_body_top_info">
            <span>Enter your payment info on the next screen*</span>
            <img src={ confPayment } alt="" />
          </div>
        </div>
      );
    } else if (this.props.copyKey === 'email_confirmation_title_contract_added') {
      copy = (
        <div className="email_confirmation_body_content_header">Thank you for registering!</div>
      );
    } else if (this.props.copyKey === 'email_confirmation_subtitle_contract_added') {
      copy = [
        <div key="conf" className="email_confirmation_body_content_body_top">
          <div className="email_confirmation_body_content_body_top_info">
            <span>The promotional plan has been added to your account.</span>
          </div>
        </div>,
        <Button key="button" className="email_confirmation_form_button" as="a" href="https://account.evgo.com/login" style={{ 'backgroundColor': '#00AEEF', 'color': '#FFFFFF' }}>Log into your account</Button>,
      ];
    } else if (this.props.copyKey === 'email_confirmation_content_8022') {
      copy = (
        <div className="email_confirmation_body_content_body_bottom">
          <div className="bullet_list">Charging is free during the 30 day promotional period*</div>
          <div className="bullet_list">There are no fees, but a credit card is required for final registration**</div>
          <div className="bullet_list">After the 30 day promotional period, you can continue to charge at 	the standard Pay As You Go rate***</div>
        </div>
      );
    } else if (this.props.copyKey === 'email_confirmation_fineprint_8022') {
      copy = (
        <div className="email_confirmation_body_content_fine_print">
          <div>*Unlimited free charging for 30 days at EVgo network chargers. Free 30 day trial begins on date of activation. Terms and conditions shall apply upon registration. After 30 days, you will only pay our Pay as You Go rates when you charge. No recurring fees. RFID card will also be issued within 7-10 business days.</div>
          <div>**Credit card required on file for final registration, but customer will not be charged during promotional period. Pay As You Go has no recurring fees. Only pay when you charge.</div>
          <div>***Standard Pay As You Go rate of $0.27-$0.35/minute depending on region and subject to change. See EVgo rates here.</div>
        </div>
      );
    } else if (this.props.copyKey === 'error_title_code_entry_3') {
      copy = 'Invalid code';
    } else if (this.props.copyKey === 'error_subtitle_code_entry_3') {
      copy = 'Please go back and enter a valid code';
    } else if (this.props.copyKey === 'error_title_code_entry_4'
        || this.props.copyKey === 'error_title_code_entry_7'
        || this.props.copyKey === 'error_title_code_entry_8') {
      copy = 'Code has already been redeemed';
    } else if (this.props.copyKey === 'error_subtitle_code_entry_4'
        || this.props.copyKey === 'error_subtitle_code_entry_7'
        || this.props.copyKey === 'error_subtitle_code_entry_8') {
      copy = 'Please go back and enter a code that has not yet been redeemed';
    } else if (this.props.copyKey === 'error_code_code_entry_8') {
      copy = `Error: ${this.props.error}`;
    } else if (this.props.copyKey === 'error_title_code_entry_5') {
      copy = 'We\'re sorry, but we have already received the first 100 registrations in your market, so we are no longer accepting new registrants for this EVgo promotion';
    } else if (this.props.copyKey === 'error_subtitle_code_entry_5') {
      copy = 'To learn more about EVgo\'s competitive retail rates, please click below';
    } else if (this.props.copyKey === 'error_button_code_entry_5') {
      copy = <Button className="error_form_button blue" as="a" href="https://www.evgo.com/charging-plans/" target="_blank" rel="noopener noreferrer">Learn More</Button>;
    } else if (this.props.copyKey === 'error_title_registration_payment_method_not_found') {
      copy = 'It looks like your existing account isn\'t activated yet';
    } else if (this.props.copyKey === 'error_subtitle_registration_payment_method_not_found') {
      copy = 'Please follow the instructions in your activation email and then try redeeming your code again';
    } else if (this.props.copyKey === 'error_button_code_entry_3'
        || this.props.copyKey === 'error_button_code_entry_4'
        || this.props.copyKey === 'error_button_code_entry_7'
        || this.props.copyKey === 'error_button_code_entry_8'
        ||this.props.copyKey === 'error_button_registration_payment_method_not_found') {
      copy = <Button className="error_form_button blue" style={{ 'backgroundColor': '#00AEEF', 'color': '#FFFFFF' }} onClick={ () => { window.location.reload(true); } }>Back</Button>;
    } else if (this.props.copyKey === 'error_title_maintenance') {
      copy = 'Under Maintenance';
    } else if (this.props.copyKey === 'error_subtitle_maintenance') {
      copy = 'Our registration system is currently undergoing maintenance. Please wait a few minutes and try refreshing the page.';
    } else if (this.props.copyKey === 'error_title_server_error'
        || this.props.copyKey === 'error_title_code_entry_1'
        || this.props.copyKey === 'error_title_code_entry_2'
        || this.props.copyKey === 'error_title_registration_6') {
      copy = 'Something went wrong';
    } else if (this.props.copyKey === 'error_subtitle_server_error'
        || this.props.copyKey === 'error_subtitle_code_entry_1'
        || this.props.copyKey === 'error_subtitle_code_entry_2'
        || this.props.copyKey === 'error_subtitle_registration_6') {
      copy = <span>Try refreshing the page. If the problem persists, contact <a href="mailto:support@evgo.com" target="_blank" rel="noopener noreferrer">support@evgo.com</a>.</span>;
    } else if (this.props.copyKey === 'error_button_server_error'
        || this.props.copyKey === 'error_button_code_entry_1'
        || this.props.copyKey === 'error_button_code_entry_2'
        || this.props.copyKey === 'error_button_registration_6'
        || this.props.copyKey === 'error_button_maintenance') {
      copy = <Button className="error_form_button blue" onClick={ () => { window.location.reload(true); } }>Refresh</Button>;
    } else if (this.props.copyKey === 'error_code_server_error'
        || this.props.copyKey === 'error_code_code_entry_1'
        || this.props.copyKey === 'error_code_code_entry_2'
        || this.props.copyKey === 'error_code_registration_6') {
      copy = `Error: ${this.props.error}`;
    } else if (this.props.copyKey === 'error_title_promo_over') {
      copy = 'We\'re sorry, but this limited-time offer is no longer available';
    } else if (this.props.copyKey === 'error_subtitle_promo_over') {
      copy = 'For more information about the EVgo network, please click below';
    } else if (this.props.copyKey === 'error_button_promo_over') {
      copy = <Button className="error_form_button blue" onClick={ () => { window.location.href = 'https://www.evgo.com/charging-plans/'; } }>Learn More</Button>;
    }

    return copy;
  }
}



// WEBPACK FOOTER //
// ./src/content/copy_provider.js